export default (function($) {
    'use strict';

    $(document).ready(function() {
        eventFilter.mark();
        $('.apply-quick-date-range').on('click', function() {
            var start = $(this).data('start');
            var end = $(this).data('end');

            $('#startDate').val(start);
            $('#endDate').val(end);
            eventFilter.build();
        });

        $('.mobile-filters').on('click', function() {
            var filters = $(this).siblings('.all-filters');
            filters.toggleClass('expanded');
        });

        $('.filter-input').on('click', function() {                    
            eventFilter.build();
        });

        $('#ApplyTermSearch').on('click', function() {                    
            eventFilter.build();
        });

        $('.apply-date-range').on('click', function(e) {

            e.preventDefault();

            eventFilter.build();
        });

        $('.clear-date-range').on('click', function(e) {

            e.preventDefault();

            eventFilter.build(true);
        });
        $('.event-pagination a').on('click', function(e) {
            e.preventDefault();

            var page = $(this).data('page');

            eventFilter.build(false, page);
        });
    });

    var eventFilter = {
        byDate: function(start, end) {

            $('.loading').show();

	        let state = history.state;
	        let title = document.title;
            let url = window.location.origin + window.location.pathname;
           
            if(start != '' && end != '') {
                url = url + '?start=' + encodeURI(start) + '&end=' + encodeURI(end);
            }
            else if(start != '') {
                url = url + '?start=' + encodeURI(start);
            }
            else if (end != ''){
                url = url + '?end=' + encodeURI(end);
            }
	            
            history.pushState(state, title, url);
        
            window.location = url;
        },
        build: function(clear, page) {

            $('.loading').show();

	        let state = history.state;
	        let title = document.title;

            let url = window.location.origin;

            var pathIndex = window.location.pathname.indexOf('page');

            if(pathIndex > 0){
                url = url + window.location.pathname.substring(0,pathIndex);
            }
            else {
                url = url + window.location.pathname;
            }

            if(!isNaN(page)){
                url = url + '/page/' + page;
            }

            var start = $('#startDate').val();
            var separator = '?';

            if (!clear && start !== '') {
                var startDate = new Date(start);
                start = startDate.toISOString().split('T')[0];
                url = url + separator + 'start=' + encodeURI(start);
                separator = '&';
            }
            
            var end = $('#endDate').val();

            if (!clear && end !== '') {
                var endDate = new Date(end);
                end = endDate.toISOString().split('T')[0];
                url = url + separator + 'end=' + encodeURI(end);
                separator = '&';
            }

            var ages = '';
            $('.age-filter:checked').each(function() {
                if(ages != '')
                {
                    ages = ages + ',';    
                }
                ages = ages + $(this).siblings('span').text();                
            });
            
            if (ages != ''){
                url = url + separator + 'ages=' + encodeURIComponent(ages);
                separator = '&';
            }

            var types = '';
            $('.types-filter:checked').each(function() {
                if(types != '')
                {
                    types = types + ',';    
                }
                types = types + $(this).siblings('span').text();                
            });
            
            if (types != ''){
                url = url + separator + 'types=' + encodeURIComponent(types);
                separator = '&';
            }

            var termSearch = $('#TermSearchBox').val();

            if(termSearch != ''){
                url = url + separator + 'term=' + encodeURIComponent(termSearch);
            }
            
            history.pushState(state, title, url);
        
            window.location = url;
        },
        mark: function() {
           var q_vars = eventFilter.getUrlVars();

           if (q_vars["types"]){
                var types = q_vars["types"].split(',');
                var ul_type = $('.filter-type');
                for (let i = 0; i < types.length; i++) {
                    if(types[i] != ''){
                        ul_type.find('.' + types[i] + ' .filter-input').prop('checked', true);
                    }
                }
           }

           if (q_vars["ages"]){
                var ages = q_vars["ages"].split(',');
                var ul_type = $('.filter-age');
                for (let i = 0; i < ages.length; i++) {
                    
                    if(ages[i] != ''){
                        ul_type.find('.' + ages[i] + ' .filter-input').prop('checked', true);
                    }
                }
            }

            if (q_vars["start"]){
                var start_date = q_vars["start"];
                var end_date = q_vars["start"];

                if (q_vars["end"]){
                    end_date = q_vars["end"];
                }

                $('.fixed-menu').find("[data-start='"+ start_date +"'][data-end='" + end_date + "']").addClass('selected');
            }     
            
            if (q_vars["term"]){
                $('#TermSearchBox').val(q_vars["term"]);
            }
        },
        getUrlVars: function ()
        {
            var vars = [], hash;
            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for(var i = 0; i < hashes.length; i++)
            {
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = decodeURIComponent(hash[1]).replaceAll(' ', '-').replaceAll('/', '').replaceAll('&', '').toLowerCase();
            }
            return vars;
        }
    };
})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/events.js